import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const TIFFIN_API = `${API_BASE_URL}/ykrestapi/Tiffin`;

const tiffinAdminService = {
  // Get all menus
  getMenus: async (orgId = 3) => {
    const response = await axios.get(`${TIFFIN_API}/admin/menus?orgId=${orgId}`);
    return response.data;
  },

  // Create or update menu
  upsertMenu: async (menuData) => {
    const response = await axios.post(`${TIFFIN_API}/admin/menu`, menuData);
    return response.data;
  },

  // Get items for a menu
  getMenuItems: async (menuId) => {
    const response = await axios.get(`${TIFFIN_API}/admin/menu/${menuId}/items`);
    return response.data;
  },

  // Create or update menu item
  upsertMenuItem: async (itemData) => {
    const response = await axios.post(`${TIFFIN_API}/admin/menu-item`, itemData);
    return response.data;
  },

  // Delete menu item
  deleteMenuItem: async (menuItemId) => {
    const response = await axios.delete(`${TIFFIN_API}/admin/menu-item/${menuItemId}`);
    return response.data;
  },

  // Upload image for menu item
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${TIFFIN_API}/admin/upload-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default tiffinAdminService;
